<app-organizer-shared-form-wrapper
  *ngIf="formGroup"
  [activeStep]="1"
  [className]="cssClass"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionDescription]="sectionDescriptionKey | translate"
  [sectionTitle]="sectionTitleKey | translate"
  (formSubmit)="submit($event)"
>
  <p [title]="formControlTitleKey | translate">
    <ng-container
      formArrayName="equipments"
      *ngFor="
        let equipment of equipmentFormControls;
        let equipmentIndex = index
      "
    >
      <ng-container [formGroupName]="equipmentIndex">
        <app-form-input-group
          [label]="getLabelName(equipmentIndex)"
          [isHiddenLabel]="true"
          [errorKey]="apiFieldName"
          [errors]="getErrors(equipment)"
          class="block mb-1"
        >
          <app-form-input
            #content
            formControlName="name"
            [rightButtonAriaLabel]="
              deleteButtonAriaLabelKey
                | translate: { name: equipment.value.name }
            "
            [rightButtonIconType]="crossIconType"
            [placeholder]="
              'activity_creation.equipment.form.input.placeholder' | translate
            "
            (keyDownEnterInput)="addEquipment($event)"
            (rightButtonClick)="deleteEquipment(equipmentIndex)"
            #equipmentInputs
          ></app-form-input>
        </app-form-input-group>
      </ng-container>
    </ng-container>
  </p>
  <button
    app-vtmn-play-button
    type="button"
    class="mt-3"
    [type]="addButtonType"
    [variant]="vtmnPlayButtonVariant.PRIMARY"
    (click)="addEquipment()"
  >
    {{ addButtonKey | translate }}
  </button>
</app-organizer-shared-form-wrapper>
